import { Link } from 'react-router-dom'

export default function EventHeader({ searchTerm, user }) {
  return (
    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-8">
      <h1 className="text-3xl font-bold text-text">
        {searchTerm ? `Garage Sales Near ${decodeURIComponent(searchTerm)}` : 'Events'}
      </h1>
      <Link
        to={user ? "/events/new" : "/login"}
        className="btn-primary"
      >
        Submit an Event
      </Link>
    </div>
  )
}
